import { getDefaultKeyBinding } from 'draft-js'

export const defaultKeyBindings = {
  keyBindingFn: (event: any) => getDefaultKeyBinding(event),
}
